// Products slider
document.addEventListener('DOMContentLoaded', function () {
    var splideMountPoint = document.querySelector('.splide');
    if (!splideMountPoint) {
        return;
    }

    var splide = new Splide('.splide', {
        perPage: 4,
        perMove: 1,
        breakpoints: {
            1023: {
                perPage: 3,
            },
            676: {
                perPage: 2,
            },
            479: {
                perPage: 1,
            },
        }
    });

    window.explode = splide;

    splide.mount();

    jQuery('body').on('product-filter/apply', function() {
        splide.refresh();
    });
});


// Recipes slider
document.addEventListener('DOMContentLoaded', function () {
    var splideMountPoint = document.querySelector('.recipes-splide');
    if (!splideMountPoint) {
        return;
    }

    var splide = new Splide('.recipes-splide', {
        type: 'loop',
        perPage: 4,
        perMove: 1,
        breakpoints: {
            1023: {
                perPage: 3,
            },
            676: {
                padding: {right: 0},
                perPage: 2,
            },
            479: {
                padding: {right: '7rem'},
                perPage: 1,
            },
            400: {
                padding: {right: '4rem'},
                perPage: 1,
            },
        },
        arrowPath: 'M19.354,11.467a.732.732,0,0,0-.006,1.078l3.8,3.568H8.682a.763.763,0,1,0,0,1.523H23.143l-3.8,3.568a.737.737,0,0,0,.006,1.078.848.848,0,0,0,1.144-.006l5.152-4.863h0a.853.853,0,0,0,.169-.24.688.688,0,0,0,.063-.293.739.739,0,0,0-.231-.533l-5.152-4.863A.834.834,0,0,0,19.354,11.467Z',
    });
    var bar = splide.root.querySelector('.slider-progress-bar');

    // Update the bar width:
    splide.on('mounted move', function () {
        var end = splide.Components.Controller.getEnd() + 1;
        bar.style.width = String(100 * (splide.index + 1) / end) + '%';
    });
    splide.mount();
});

// News slider
document.addEventListener('DOMContentLoaded', function () {
    var splideMountPoint = document.querySelector('.news-splide');
    if (!splideMountPoint) {
        return;
    }

    var splide = new Splide('.news-splide', {
        breakpoints: {
            1023: {
                perPage: 3,
            },
            676: {
                padding: {right: 0},
                perPage: 2,
            },
            479: {
                padding: {right: '7rem'},
                perPage: 1,
            },
            400: {
                padding: {right: '4rem'},
                perPage: 1,
            },
        },
        type: 'loop',
        perPage: 4,
        perMove: 1,
        arrowPath: 'M19.354,11.467a.732.732,0,0,0-.006,1.078l3.8,3.568H8.682a.763.763,0,1,0,0,1.523H23.143l-3.8,3.568a.737.737,0,0,0,.006,1.078.848.848,0,0,0,1.144-.006l5.152-4.863h0a.853.853,0,0,0,.169-.24.688.688,0,0,0,.063-.293.739.739,0,0,0-.231-.533l-5.152-4.863A.834.834,0,0,0,19.354,11.467Z',
    });
    var bar = splide.root.querySelector('.slider-progress-bar');

    // Update the bar width:
    splide.on('mounted move', function () {
        var end = splide.Components.Controller.getEnd() + 1;
        bar.style.width = String(100 * (splide.index + 1) / end) + '%';
    });
    splide.mount();
});

// Gallery slider
document.addEventListener('DOMContentLoaded', function () {
    var splideMountPoint = document.querySelector('.gallery-splide');
    if (!splideMountPoint) {
        return;
    }

    var splide = new Splide('.gallery-splide', {
        type: 'loop',
        arrowPath: 'M19.354,11.467a.732.732,0,0,0-.006,1.078l3.8,3.568H8.682a.763.763,0,1,0,0,1.523H23.143l-3.8,3.568a.737.737,0,0,0,.006,1.078.848.848,0,0,0,1.144-.006l5.152-4.863h0a.853.853,0,0,0,.169-.24.688.688,0,0,0,.063-.293.739.739,0,0,0-.231-.533l-5.152-4.863A.834.834,0,0,0,19.354,11.467Z',
    });

    splide.mount();
});


// Friends slider
document.addEventListener('DOMContentLoaded', function () {
    var splideMountPoint = document.querySelector('.our-friends-splide');
    if (!splideMountPoint) {
        return;
    }

    var splide = new Splide('.our-friends-splide', {
        breakpoints: {
            1023: {
                perPage: 3,
            },
            676: {
                padding: {right: 0},
                perPage: 2,
            },
            479: {
                padding: {right: '7rem'},
                perPage: 1,
            },
            400: {
                padding: {right: '4rem'},
                perPage: 1,
            },
        },
        type: 'loop',
        perPage: 4,
        perMove: 1,
        arrowPath: 'M19.354,11.467a.732.732,0,0,0-.006,1.078l3.8,3.568H8.682a.763.763,0,1,0,0,1.523H23.143l-3.8,3.568a.737.737,0,0,0,.006,1.078.848.848,0,0,0,1.144-.006l5.152-4.863h0a.853.853,0,0,0,.169-.24.688.688,0,0,0,.063-.293.739.739,0,0,0-.231-.533l-5.152-4.863A.834.834,0,0,0,19.354,11.467Z',
    });
    var bar = splide.root.querySelector('.slider-progress-bar');

    // Update the bar width:
    splide.on('mounted move', function () {
        var end = splide.Components.Controller.getEnd() + 1;
        bar.style.width = String(100 * (splide.index + 1) / end) + '%';
    });

    splide.mount();
});
